import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

import { CreateSegmentModal } from '@/src/ContactsModule/components/ContactsModals';

interface IMutationCreateSegmentModalContext {
  setCreateSegmentModal: Dispatch<SetStateAction<boolean>>;
}

type ICreateSegmentModalContext = boolean;

interface CreateSegmentModalProps {
  children: ReactNode;
}

const MutationCreateSegmentModalContext = createContext<
  IMutationCreateSegmentModalContext | undefined
>(undefined);
const StateCreateSegmentModalContext = createContext<ICreateSegmentModalContext | undefined>(
  undefined
);

const CreateSegmentModalProvider = ({ children }: CreateSegmentModalProps) => {
  const [createSegmentModal, setCreateSegmentModal] = useState<boolean>(false);

  const memoizedMutation = useMemo<IMutationCreateSegmentModalContext>(
    () => ({
      setCreateSegmentModal,
    }),
    [setCreateSegmentModal]
  );

  return (
    <MutationCreateSegmentModalContext.Provider value={memoizedMutation}>
      <StateCreateSegmentModalContext.Provider value={createSegmentModal}>
        {createSegmentModal && <CreateSegmentModal setShowModal={setCreateSegmentModal} />}
        {children}
      </StateCreateSegmentModalContext.Provider>
    </MutationCreateSegmentModalContext.Provider>
  );
};

export const useStateCreateSegmentModalContext = (): ICreateSegmentModalContext =>
  useGetContext<ICreateSegmentModalContext>(StateCreateSegmentModalContext);

export const useMutationCreateSegmentModalContext = (): IMutationCreateSegmentModalContext =>
  useGetContext<IMutationCreateSegmentModalContext>(MutationCreateSegmentModalContext);

const useGetContext = <T,>(contextName: React.Context<T | undefined>): T => {
  const context = useContext<T | undefined>(contextName);
  if (!context) {
    throw new Error('CreateSegmentModalProvider is required');
  }
  return context;
};

export default CreateSegmentModalProvider;
